import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { lpForm } from 'lp-form'
import { SubmitButton, ButtonArea, Textarea } from 'lp-components'
import { Field, propTypes as formPropTypes } from 'redux-form'

const propTypes = {
  ...formPropTypes,
  onClose: PropTypes.func.isRequired,
  reasonLabel: PropTypes.string,
  submitLabel: PropTypes.string,
}

const defaultProps = {
  reasonLabel: null,
  submitLabel: null,
}

function FlagForm({
  handleSubmit,
  submitting,
  onClose,
  reasonLabel,
  submitLabel,
}) {
  const resolvedReasonLabel =
    reasonLabel ||
    'Please let us know why you are flagging this as inappropriate'
  const resolvedSubmitLabel = submitLabel || 'Submit Flag'

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Field name="reason" label={resolvedReasonLabel} component={Textarea} />
      <ButtonArea>
        <SubmitButton submitting={submitting}>
          {resolvedSubmitLabel}
        </SubmitButton>
        <button type="button" className="button-grey-light" onClick={onClose}>
          Cancel
        </button>
      </ButtonArea>
    </form>
  )
}

FlagForm.propTypes = propTypes
FlagForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'flag-new',
    constraints: {
      reason: {
        presence: true,
      },
    },
  })
)(FlagForm)
